import {useGetAuditTrail} from '../providers/AuditTrail.provider'

export function useAuditTrail() {
  const auditTrail = useGetAuditTrail();

  return ({
    auditTrail
  });
}